import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import CloudUseCaseComponent from '../components/CloudUseCaseComponent'
import ChallengeOpportunity from '../components/ChallengeOpportunity'
import ProplusdataApproach from '../components/ProplusdataApproach'
import SolutionLeveraged from '../components/SolutionsLeveraged'
import HighMediumComponent from '../components/HighMediumComponent'
import MessagingConverts from '../components/MessagingConverts'
import TimelineComponent from '../components/TimelineComponent'
import CtaAwsCaseStudy from '../components/CtaAwsCaseStudy'
import CloudContent from '../components/CloudContent'

export default function ProPlusRenewalIntelligenceBoostsCloudEnterprisePipleline3X() {
  return (
    <div>
      <Header1/>
      <CloudUseCaseComponent/>
      <CloudContent/>
      <ChallengeOpportunity/>
       <SolutionLeveraged/>
      <ProplusdataApproach/>
      <HighMediumComponent/>
      <MessagingConverts/>
      <TimelineComponent/>
      <CtaAwsCaseStudy/>
      <Footer/>
    </div>
  )
}
